import { all, call, put, select, take } from 'redux-saga/effects';

import { GET_NAVIGATION_INFO } from './actions';
import { notifications, SET_ISLOADING } from 'PipeRouter';

import { getPreviousPageInfo, getNextPageInfo } from 'Services/learnkit';


function* getNavigationInfo() {
  while (true) {
    yield take(GET_NAVIGATION_INFO);

    const { ebook } = yield select(state => state.reader);

    const [prevPageInfo, nextPageInfo] = yield all([
      call(getPreviousPageInfo),
      call(getNextPageInfo)
    ]);

    yield put({
      type: 'SAVE_NAVIGATION_INFO',
      data: {
        prevPageInfo: prevPageInfo.data,
        currentPage: {
          cfi: ebook.cfi
        },
        nextPageInfo: nextPageInfo.data
      }
    });
    yield put(notifications(SET_ISLOADING, false));
  }
}


export default getNavigationInfo;
